import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('TransactionStatus').create(({ theme }) => ({
  root: {
    width: '100%',
    height: '56px',
    borderRadius: theme.sizes.radiuses.l,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    background: 'white',
    gap: '4px',
    padding: '0px 12px',
    '&[data-variant="processing"]': {
      background: '#ffbb00',
    },
    '&[data-variant="success"]': {
      background: '#72da41',
    },
  },

  text: {
    fontFamily: 'Inter',
    fontWeight: '450',
    fontSize: theme.sizes.texts.fontSize.s,
    lineHeight: '100%',
    letterSpacing: '-1%',
  },
}))
